import {PrescriptionType} from './prescriptionTypes';
import {NOT_SELECTED} from 'constants/wizard/prescriptionType';

export const NONE = 'None';

export const initialState: PrescriptionType = {
    id: 0,
    name: '',
    comment: '',
    method: NOT_SELECTED,
    file: {
        error: '',
        file: {},
        fileSrc: '',
    },
    od: {
        sph: NONE,
        cyl: NONE,
        axi: NONE,
        add: NONE,
    },
    os: {
        sph: NONE,
        cyl: NONE,
        axi: NONE,
        add: NONE,
    },
    pd: {
        singular: '62',
        right: '35.5',
        left: '35.5',
        near: '59',
    },
    isMultiPD: false,
    status: '',
};
